var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"elePowerBox"},[_c('div',{staticClass:"powerTop"},[_c('div',[_vm._v(_vm._s(_vm.elePowerTitle))]),_c('div',[_vm._t("time")],2)]),_c('div',{staticClass:"powerMain"},[_vm._t("main")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }